import React, { useMemo } from 'react'

import { EmptyState } from 'partials/EmptyState'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { FlatList } from 'widgets/FlatList'

import { useLeaderboard } from 'hooks/useLeaderboard'

import commonStyles from 'utils/styles/commonStyles'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'
import { useFocusMode } from 'contexts/FocusModeContext'

import { UserType } from 'types/user'

export const Leaderboard = () => {
  const createPostModalRef = useCreatePostModal()
  const focusMode = useFocusMode()

  const { data: leaders, isLoading: isLoadingLeaders } = useLeaderboard({
    trainerId: focusMode?.group?.trainer.id,
  })

  const showEmptyState = useMemo(
    () => !isLoadingLeaders && leaders && leaders.length === 0,
    [isLoadingLeaders, leaders],
  )

  return (
    <>
      {!isLoadingLeaders && (
        <Box
          flexDirection='row'
          justifyContent='flex-start'
          width='100%'
          margin={{ vertical: showEmptyState ? 'lg' : undefined }}
        >
          {showEmptyState ? (
            <EmptyState
              inBetweenMargin='sm'
              title='Get on the leaderboard!'
              subtitle='Complete a workout or share an activity.'
              actionButtons={[
                {
                  title: 'Share Activity',
                  type: 'primary',
                  onPress: () => createPostModalRef?.current?.present(),
                },
              ]}
            />
          ) : (
            <FlatList<UserType>
              horizontal
              data={leaders}
              loading={isLoadingLeaders}
              renderItem={({ item: leader }) => (
                <CoachItem user={leader} isFeedHeader isMember withUpscoreBadge />
              )}
              keyExtractor={(leader) => `Leader-${leader.id}`}
              testID='LeaderboardList'
              noContentProps={{
                marginTop: 50,
                marginBottom: 50,
                message: 'There is no one on the leaderboard right now',
              }}
              contentContainerStyle={commonStyles.flexGrow}
            />
          )}
        </Box>
      )}
    </>
  )
}
